/* eslint-disable import/no-cycle */
import { JobListResponse, JobListTable, RequestBody } from './types';

export function convertApiDataToTable(apiResponse: JobListResponse[]) {
  const tableData: JobListTable[] = [];
  apiResponse.map((item) => {
    tableData.push({
      activeDays: item.activeDays,
      clientId: item.clientId,
      createdDate: item.createdDate,
      jobId: item.jobId,
      location: item.location,
      jobOrderId: item.jobOrderId,
      jobTitle: item.jobTitle,
      recruiters: item.recruiters,
      status: item.status,
      submitted: item.submitted,
      total: item.total,
      vendors: item.vendors,
      postOnWebSite: item.postOnWebSite,
      internalLink: item.internalLink,
      externalLink: item.externalLink,
      updatedDate: item.updatedDate,
      interviewPositionId: item.interviewPositionId,
    });
    return item;
  });

  return tableData;
}

export const jobStatusList = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Archived', value: 'ARCHIVED' },
  { label: 'Halted', value: 'HALTED' },
  { label: 'Do Not Work', value: 'DO_NOT_WORK' },
];

export function createNewJobRequestBody(data: any) {
  return {
    clientId: data?.clientId,
    clientName: data?.clientName,
    jobId: data?.jobId,
    jobTitle: data?.jobTitle,
    requirementType: data?.requirementType,
    vendor: data?.vendor,
    jobType: data?.jobType,
    jobDuration: data?.jobDuration,
    payRate: data?.payRate,
    jobLocation: data?.jobLocation,
    skills: data?.skills,
    jobOrderDescription: data?.jobOrderDescription,
    documents: data?.documents,
    jobOrderRecruiters: data?.jobOrderRecruiters,
  } as unknown as RequestBody;
}

class Utils {
  static prepareCreateJobRequestObject = (data: RequestBody) => {
    const finalRequestData = new FormData();
    const createJobFormData = {
      clientId: data?.clientId,
      jobId: data?.jobId,
      jobTitle: data?.jobTitle,
      requirementType: data?.requirementType,
      vendor: data?.vendor,
      jobType: data?.jobType,
      jobDuration: data?.jobDuration,
      jobDurationPeriod: data?.jobDurationPeriod,
      payRateMin: data?.payRateMin,
      payRateMax: data?.payRateMax,
      payRateType: data?.payRateType,
      jobLocations: data?.jobLocations,
      skills: data?.skills,
      jobOrderDescription: data?.jobOrderDescription,
      jobOrderRecruiters: data?.jobOrderRecruiters,
      currency: data?.currency,
    };
    finalRequestData.append('formData', JSON.stringify(createJobFormData));
    const documents = data?.documents;
    if (documents instanceof File) {
      finalRequestData.append('fileURL', documents);
    }

    return finalRequestData;
  };
}

export default Utils;
